// 认证 API 客户端（平迁到 Laravel 后端 api.yl8888.cn）
//
// 为什么不复用 apiClient：
//   apiClient.request() 会给 /api/* 强制加尾斜杠，Laravel 不 trim 会 404。
//   这里参照 contentApi 的写法，不加尾斜杠，且与内容 API 同源。
//
// 方法签名与旧 apiClient 的 auth 方法对齐（body 对象），调用点只需 api -> authApi。

const AUTH_API_BASE = process.env.REACT_APP_CONTENT_API_BASE || 'https://api.yl8888.cn';

async function requestAuth(path, { method = 'GET', body, token } = {}) {
  const headers = { 'Content-Type': 'application/json' };
  if (token) {
    headers.Authorization = `Bearer ${token}`;
  }

  const res = await fetch(`${AUTH_API_BASE}${path}`, {
    method,
    headers,
    body: body ? JSON.stringify(body) : undefined,
  });

  let data = null;
  try {
    data = await res.json();
  } catch (_) {
    // 忽略非 JSON 响应
  }

  if (!res.ok) {
    const message = (data && (data.message || data.error)) || `Request failed (${res.status})`;
    const err = new Error(message);
    err.status = res.status;
    err.payload = data;
    throw err;
  }

  return data;
}

export const authApi = {
  register(body) {
    return requestAuth('/api/v1/auth/register', { method: 'POST', body });
  },

  login(body) {
    return requestAuth('/api/v1/auth/login', { method: 'POST', body });
  },

  verifyToken(token) {
    return requestAuth('/api/v1/auth/verify', { method: 'POST', body: { token } });
  },

  updateProfile(body) {
    return requestAuth('/api/v1/auth/profile', { method: 'POST', body });
  },

  resetPassword(body) {
    return requestAuth('/api/v1/auth/reset-password', { method: 'POST', body });
  },

  getShippingProfile(token) {
    return requestAuth('/api/v1/auth/shipping-profile', { token });
  },

  saveShippingProfile(token, body) {
    return requestAuth('/api/v1/auth/shipping-profile', { method: 'POST', body, token });
  },
};
